<template>
	<div class="table-mode">
		<div class="table-title">Choose source</div>
		<SelectTableDataInput v-model="tableSource" inputFieldHint="Choose table source" />
		<div class="px-2 pt-2 options">
			<div v-if="tableSource" class="pt-2">
				<div class="option">Choose column</div>
				<v-autocomplete
					dense
					outlined
					hide-details
					v-model="tableTextColumn"
					item-value="field"
					item-text="field"
					:items="columnOptions"
					placeholder="Select an option"
				>
					<template v-slot:selection="{ item }">
						{{ stringDisplay(item.field) }}
					</template>
					<template v-slot:item="{ item }">
						<DataTableRepresentation
							v-if="isTable(item.exampleData)"
							:listKey="item.field"
							:input="item.exampleData"
							:nodeUUID="String(editNode.id)"
							:useWithFormulas="true"
						/>
						<div v-else class="string-field">{{ stringDisplay(item.field) }}</div>
					</template>
				</v-autocomplete>
			</div>
			<div v-if="tableSource && isOptionValue">
				<div class="option">Choose source value</div>
				<v-autocomplete
					dense
					outlined
					hide-details
					v-model="tableValueColumn"
					:items="columnOptions"
					item-value="field"
					item-text="field"
					placeholder="Select an option"
				>
					<template v-slot:selection="{ item }">
						{{ stringDisplay(item.field) }}
					</template>
					<template v-slot:item="{ item }">
						<DataTableRepresentation
							v-if="isTable(item.exampleData)"
							:listKey="item.field"
							:input="item.exampleData"
							:nodeUUID="String(editNode.id)"
							:useWithFormulas="true"
						/>
						<div v-else class="string-field">{{ stringDisplay(item.field) }}</div>
					</template>
				</v-autocomplete>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isArrayOfObjects } from '@/utils/helpers';
import { editNode } from '@/store/modules/selectedNode/getters';
import { getPreviousStepDataForNodeByUUID } from '@/store/modules/nodes/getters';
import { replaceInsertDataStringDictionary } from '@/store/modules/selectedWorkflow/getters';
import SelectTableDataInput from '@/components/DataInput/DataInputFields/SelectTableDataInput';
import DataTableRepresentation from '@/components/DataTableRepresentation/DataTableRepresentation';
import TableActionEditorService from '../../../BlockEditor/TableActionEditor/table-action-edtior-service';
import { configurationsMappingBlocksUUIDs } from '@/store/modules/selectedWorkflow/modules/configurations/getters';

export default {
	name: 'MultipleSelectTableSourceSettingsEditor',
	components: {
		SelectTableDataInput,
		DataTableRepresentation,
	},
	props: {
		localField: { type: Object },
	},
	computed: {
		...mapGetters([
			getPreviousStepDataForNodeByUUID.fullPath,
			editNode.fullPath,
			replaceInsertDataStringDictionary.fullPath,
			configurationsMappingBlocksUUIDs.fullPath,
		]),
		editNode() {
			return this[editNode.fullPath];
		},
		tableSource: {
			get() {
				return this.localField.metadata.options.previous_steps.table_mode_source.value;
			},
			set(value) {
				this.$emit('updateLocalField', { key: 'metadata.options.previous_steps.table_mode_source.value', value });
			},
		},
		tableTextColumn: {
			get() {
				return this.localField.metadata.options.table_mode.text_column;
			},
			set(value) {
				this.$emit('updateLocalField', { key: 'metadata.options.table_mode.text_column', value });
			},
		},
		tableValueColumn: {
			get() {
				return this.localField.metadata.options.table_mode.value_column;
			},
			set(value) {
				this.$emit('updateLocalField', { key: 'metadata.options.table_mode.value_column', value });
			},
		},
		tableSourceRows() {
			return (
				TableActionEditorService.rowsFromPreviousSteps(
					this.tableSource,
					this[getPreviousStepDataForNodeByUUID.fullPath],
					this[replaceInsertDataStringDictionary.fullPath],
					this[configurationsMappingBlocksUUIDs.fullPath]
				) || []
			);
		},
		columnOptions() {
			if (!this.tableSource) {
				return [];
			}
			const options = TableActionEditorService.columnDefsFromPreviousSteps(this.tableSourceRows, true);
			return options.map((o) => ({ ...o, disabled: this.isTable(o.exampleData) }));
		},
		isOptionValue() {
			return this.localField.metadata.options?.option_value?.enabled;
		},
	},
	methods: {
		isTable(value) {
			return isArrayOfObjects(value);
		},
		stringDisplay(value) {
			// todo - rethink this. this can be buggy if the input itself has a dot
			return value.replace(/\./g, ' » ');
		},
	},
};
</script>

<style scoped lang="scss">
.options {
	opacity: 0.7;
}
.option,
.table-title {
	font-size: 12px;
	font-weight: 400;
}
.string-field {
	color: #444e5f;
	font-size: 14px;
}
</style>
